import { StateType } from 'data/types'

import { ReferralState } from './slice'

const get = (state: StateType): ReferralState => state.referral

export const isFetching = (state: StateType) => get(state).fetching ?? false

export const hasError = (state: StateType) => get(state).hasError

export const getInfo = (state: StateType) => get(state).data
